/**
 * Payment Module
 */

const state = {
  paymentOptions: [],
  isWalletLoading: true,
  isPaymentOptionsLoading: true,
  wallet: null,
  transactions: [],
  isInvoicesLoading: true,
  isTransactionsLoading: true,
  countryPaymentGateway: {},
  didTransferFail: false,
  isTranferInProgress: false,
  isTransferSuccessful: false
}

// getters
const getters = {
  paymentOptions: state => state.paymentOptions,
  isWalletLoading: state => state.isWalletLoading,
  isPaymentOptionsLoading: state => state.isPaymentOptionsLoading,
  wallet: state => state.wallet,
  transactions: state => state.transactions,
  isInvoicesLoading: state => state.isInvoicesLoading,
  isTransactionsLoading: state => state.isTransactionsLoading,
  countryPaymentGateway: state => state.countryPaymentGateway,
  didTransferFail: state => state.didTransferFail,
  isTranferInProgress: state => state.isTranferInProgress,
  isTransferSuccessful: state => state.isTransferSuccessful
}

// actions
const actions = {
  setIsLoading(context, payload) {
    context.commit('setIsLoading', payload);
  },
  setWallet(context, payload) {
    context.commit('setWallet', payload);
  },
  setPaymentOptions(context, payload) {
    context.commit('setPaymentOptions', payload);
  },
  setTransactions(context, payload) {
    context.commit('setTransactions', payload);
  },
  setCountryPaymentGateway(context, payload) {
    context.commit('setCountryPaymentGateway', payload);
  }
}

// mutations
const mutations = {
  setPaymentOptions(state, paymentOptions) {
    state.paymentOptions = paymentOptions;
  },
  setIsLoading(state, payload) {
    const { isPaymentOptionsLoading, isWalletLoading, isInvoicesLoading, isTransactionsLoading, isTranferInProgress, didTransferFail, isTransferSuccessful } = payload;
    state.isPaymentOptionsLoading = (isPaymentOptionsLoading === undefined || isPaymentOptionsLoading === null) ? state.isPaymentOptionsLoading : isPaymentOptionsLoading;
    state.isWalletLoading = (isWalletLoading === undefined || isWalletLoading === null) ? state.isWalletLoading : isWalletLoading;
    state.isInvoicesLoading = (isInvoicesLoading === undefined || isInvoicesLoading === null) ? state.isInvoicesLoading : isInvoicesLoading;
    state.isTransactionsLoading = (isTransactionsLoading === undefined || isTransactionsLoading === null) ? state.isTransactionsLoading : isTransactionsLoading;
    state.isTranferInProgress = (isTranferInProgress === undefined || isTranferInProgress === null) ? state.isTranferInProgress : isTranferInProgress;
    state.didTransferFail = (didTransferFail === undefined || didTransferFail === null) ? state.didTransferFail : didTransferFail;
    state.isTransferSuccessful = (isTransferSuccessful === undefined || isTransferSuccessful === null) ? state.isTransferSuccessful : isTransferSuccessful;
  },
  setWallet(state, wallet) {
    state.wallet = wallet;
  },
  setTransactions(state, transactions) {
    state.transactions = transactions;
  },
  setCountryPaymentGateway(state, paymentGateway) {
    state.countryPaymentGateway = paymentGateway
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}